<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        :columns="columns"
        :mod-count="modCount"
        :offset-height="offsetHeight"
        :url="url"
        :search-form-fields="formFields"
        @on-add="showFormModalDialog"
      />
    </div>
    <VehicleTypeDialog
      :id="entityId"
      :visible="modalForm"
      :width="400"
      :action="url"
      @on-close="onModalClose"
    />
  </div>
</template>

<script>
import VehicleTypeDialog from './dialog/vehicleTypeDialog'
import TableWrapper from '@/components/table-wrapper'
import request from '@/utils/request'
export default {
  name: 'VehicleTypeList',
  components: {
    TableWrapper, VehicleTypeDialog
  },
  data() {
    return {
      entityId: 0,
      modCount: 0,
      modalForm: false,
      url: this.$config.apiContextPath + '/vehicle/type',
      garages: this.loadGarages()
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '绑定车库', placeholder: '请选择绑定车库...', name: 'parkingId', width: 'auto', type: 'select', options: this.garages },
          { label: '车辆类型', placeholder: '请输入车辆类型...', name: 'name', width: 'auto', type: 'input' }
        ]
      }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '绑定车库', align: 'left', key: 'parking', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.parking || '---')
          }
        },
        { title: '类型', align: 'left', key: 'name', sortable: true },
        { title: '备注', align: 'left', key: 'remarks', sortable: true,
          render: (h, params) => {
            return h('span', {}, params.row.remarks || '---')
          }
        },
        { title: '创建时间', align: 'center', key: 'createTime', sortable: true, width: 160 },
        { title: '更新时间', align: 'center', key: 'updateTime', sortable: true, width: 160,
          render: (h, params) => {
            return h('span', {}, params.row.updateTime || '---')
          }
        },
        { title: '操作', align: 'center', width: 185,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.name)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ])
            ])
          }
        }]
    }
  },
  methods: {
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = []
        const items = res.data
        items.forEach(i => {
          this.garages.push({ label: i.name, value: i.id })
        })
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    showDelModalDialog: function(id, name) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除`' + name + '`车辆类型么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, name)])
        },
        onOk: function() {
          const _that = this
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '车辆类型 `' + name + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '车辆类型 `' + name + '` 删除失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    }
  }
}
</script>

